import { colors as figmaColors } from "./generated";
export var shadeMap = {
    lightest: 50,
    lighter: 100,
    light: 300,
    base: 500,
    dark: 700,
    darker: 800,
    darkest: 900,
};
export var createColor = function (_a) {
    var lightest = _a.lightest, lighter = _a.lighter, light = _a.light, base = _a.base, dark = _a.dark, darker = _a.darker, darkest = _a.darkest;
    return {
        50: lightest,
        100: lighter,
        200: light,
        300: light,
        400: base,
        500: base,
        600: dark,
        700: dark,
        800: darker,
        900: darkest,
    };
};
var blue = createColor(figmaColors.blue);
var green = createColor(figmaColors.green);
var magenta = createColor(figmaColors.magenta);
var purple = createColor(figmaColors.purple);
var red = createColor(figmaColors.red);
var yellow = createColor(figmaColors.yellow);
var neutral = createColor(figmaColors.neutral);
export var colors = {
    blue: blue,
    green: green,
    magenta: magenta,
    purple: purple,
    red: red,
    yellow: yellow,
    neutral: neutral,
};
export var getShadeOfColor = function (color, shade) {
    if (shade === void 0) { shade = "base"; }
    var shadeValue = shadeMap[shade];
    return colors[color][shadeValue];
};
